<template>
    <div :class="classMainBlock">
        <label :for="id">
            {{ title }}
        </label>
        <date-range-picker
            id="filter_dates"
            ref="picker"
            v-model="itemModel"
            :append-to-body="appendToBody"
            :locale-data="localeData"
            :maxDate="maxDate"
            :ranges="false"
            :singleDatePicker="true"
            :time-picker24-hour="false"
            opens="right"
            @update="change"
        >
            <template #input>
                <input
                    :value="getValue()"
                    class="date-range-picker-input"
                    @input="changeItemModel"
                />
            </template>
        </date-range-picker>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
        classMainBlock: {
            type: String,
            default: '',
        },
        start: {
            type: String,
            default: '',
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
        disableFutureDates: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        const today = window.moment().endOf('day');

        return {
            itemModel: {},
            itemValue: null,
            localeData: {
                format: 'YYYY-MM-DD',
                firstDay: 0,
            },
            maxDate: this.disableFutureDates ? today.format('YYYY-MM-DD') : null,
        };
    },
    watch: {
        start: function () {
            this.init();
        },
        disableFutureDates: function () {
            const today = window.moment().endOf('day');
            this.maxDate = this.disableFutureDates ? today.format('YYYY-MM-DD') : null;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        validateManualValue(startDate) {
            if (!startDate || !startDate.isValid()) {
                return false;
            }

            if (!this.disableFutureDates) {
                return true;
            }

            const today = window.moment().endOf('day');

            return !startDate.isAfter(today, 'day');
        },
        changeItemModel(event) {
            const value = event.target.value ? event.target.value.replace(' ', '') : '';
            const startDate = window.moment(value, 'YYYY-MM-DD', true);

            this.validateManualValue(startDate) && this.setModel(startDate);
            this.change();
        },
        init() {
            let startDate = null;

            if (this.start) {
                startDate = window.moment(this.start, 'YYYY-MM-DD');
            }

            if (startDate) {
                this.setModel(startDate);
                this.setValue();
            } else {
                this.clear();
            }
        },
        convertByFormat(value) {
            return value ? window.moment(value.toISOString()).format('YYYY-MM-DD') : '';
        },
        change() {
            this.setValue();
            this.$emit('change', this.getValue());
        },
        getValue() {
            return this.itemValue;
        },
        setModel(startDate) {
            this.itemModel = {
                startDate,
            };
        },
        setValue() {
            this.itemValue = this.itemModel.startDate ? this.convertByFormat(this.itemModel.startDate) : null;
        },
        clear() {
            this.itemModel = {};
            this.itemValue = null;
        },
    },
};
</script>
